module.exports = __webpack_public_path__ + "img/adaptive-logo-without-name.06912881.png";